import { render, staticRenderFns } from "./StoreEventTypeForm.vue?vue&type=template&id=536a4c4a&"
import script from "./StoreEventTypeForm.vue?vue&type=script&lang=js&"
export * from "./StoreEventTypeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports